/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Line, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function MagnifyingGlassMinus(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Line
        x1={83.99805}
        y1={116}
        x2={147.99805}
        y2={116}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Circle
        cx={115.99805}
        cy={115.99707}
        r={84}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Line
        x1={175.39161}
        y1={175.39747}
        x2={223.99219}
        y2={223.99805}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default MagnifyingGlassMinus;
